

































































































































































































































































































































































































import {Vue, Component, Prop, Watch, Emit} from 'vue-property-decorator';
import {Mutation, State} from "vuex-class";
import cookies from "@/services/cookies.service";;
import authService from '@/services/auth.service';
import mainMenu from './Menu';
import {setStyleSheet} from "@/utils/StyleSheet";
import * as signalR from "@aspnet/signalr";
import dataProxy from '@/services/data-proxy.service';

declare const $: any;

@Component({})
export default class Shell extends Vue {
    @State('loggedUser') user!: string;
    @State('tenantName') tenant!: string;
    @Mutation('setLoggedUser') setUser;
    @State('menuEnlarged') menuEnlarged;
    @State('avatar') avatar;
    @State permissions;
    @State isSuperAdmin;

    mainMenu = mainMenu;
    isFullScreen = false;
    messages = [];

    async created() {
        const connection = new signalR.HubConnectionBuilder().withUrl("/hubs/notifications").build();
        connection.on("SendNotification", this.notificationReceived);
        await connection.start();
    }

    mounted() {
        const $body = $('body');
        const $window = $(window);

        $(".slimscroll").slimScroll({
            height: 'auto',
            position: 'right',
            size: "8px",
            touchScrollStep: 20,
            color: '#9ea5ab'
        });

        $("#side-menu").metisMenu();

        this.resetSidebarScroll();
        this.initLayout();
        $window.on('resize', () => {
            this.resetSidebarScroll();
            this.initLayout();
        });

        $('.button-menu-mobile').on('click', (event) => {
            event.preventDefault();
            $body.toggleClass('sidebar-enable');
            if ($window.width() >= 768) {
                $body.toggleClass('enlarged');
            } else {
                $body.removeClass('enlarged');
            }
            // sidebar - scroll container
            this.resetSidebarScroll();
        });
    }

    logout() {
        authService.logout();
        this.$router.push('/login');
    }

    toggleFullScreen() {
        if (!this.isFullScreen) {
            this.openFullScreen();
            this.isFullScreen = true;
        } else {
            this.closeFullScreen();
            this.isFullScreen = false;
        }
    }

    switchToLightTheme() {
        setStyleSheet('assets/lightTheme/app.min.css', 'assets/lightTheme/bootstrap.min.css', 'assets/lightTheme/custom.css');
    }

    switchToDarkTheme() {
        setStyleSheet('assets/darkTheme/app.min.css', 'assets/darkTheme/bootstrap.min.css', 'assets/darkTheme/custom.css');
    }

    notificationReceived(notification: any) {
        this.messages.unshift(notification);
    }

    obrisiPoruke() {
        this.messages = [];
    }

    @Watch('menuEnlarged') onMenuEnlargedChanged(isEnlarged) {
        const $body = $('body');
        console.log('isEnlarged', isEnlarged);
        if (isEnlarged) {
            $body.removeClass('enlarged');
        } else {
            $body.addClass('enlarged');
        }
        // sidebar - scroll container
        this.resetSidebarScroll();
    }

    @Watch('permissions') onPermissionsLoaded() {

    }

    hasPermission(menuItem) {
        return this.isSuperAdmin || this.permissions.indexOf(menuItem.name) > -1;
    }

    async pretraziVozilo(field: any) {
        if (field.value) {
            const vozilo = await dataProxy.vratiVoziloPoRegistraskomIliGaraznomBroju(field.value);
            if (vozilo) {
                field.value = null;
                await this.$router.push(`/podaci-vozila/${vozilo.id}`);
            } else {
                $.toast({heading: this.$i18n.t('rezultatPretrage'),
                    text: this.$i18n.t('voziloNijePronadjeno'),
                    position:"top-right",
                    loaderBg:"#3b98b5",
                    icon:"info",
                    hideAfter:3e3,
                    stack:1
                });
            }
        }
    }

    private openFullScreen() {
        const elem: any = document.documentElement;
        if (elem.requestFullscreen) {
            elem.requestFullscreen();
        } else if (elem.mozRequestFullScreen) { /* Firefox */
            elem.mozRequestFullScreen();
        } else if (elem.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
            elem.webkitRequestFullscreen();
        } else if (elem.msRequestFullscreen) { /* IE/Edge */
            elem.msRequestFullscreen();
        }
    }

    private closeFullScreen() {
        const doc: any = document;
        if (document.exitFullscreen) {
            document.exitFullscreen();
        } else if (doc.mozCancelFullScreen) { /* Firefox */
            doc.mozCancelFullScreen();
        } else if (doc.webkitExitFullscreen) { /* Chrome, Safari and Opera */
            doc.webkitExitFullscreen();
        } else if (doc.msExitFullscreen) { /* IE/Edge */
            doc.msExitFullscreen();
        }
    }

    private resetSidebarScroll() {
        $('.slimscroll-menu').slimscroll({
            height: 'auto',
            position: 'right',
            size: "8px",
            color: '#9ea5ab',
            wheelStep: 5,
            touchScrollStep: 20
        });
    }

    private initLayout() {
        const $body = $('body');
        const $window = $(window);

        if ($window.width() >= 768 && $window.width() <= 1024) {
            $body.addClass('enlarged');
        } else {
            if ($body.data('keep-enlarged') != true) {
                $body.removeClass('enlarged');
            }
        }
    }
}
